import PaginationSummary from './PaginationSummary';

export default PaginationSummary;
